import { render } from "./QuizParametersModal.vue?vue&type=template&id=05dfd474&scoped=true"
import script from "./QuizParametersModal.vue?vue&type=script&lang=js"
export * from "./QuizParametersModal.vue?vue&type=script&lang=js"

import "./QuizParametersModal.vue?vue&type=style&index=0&id=05dfd474&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05dfd474"]])

export default __exports__